<template>
  <div class="ele-body">
    <el-card shadow="never" v-loading="loading" body-style="padding-bottom: 0;">
      <el-row :gutter="15">
        <el-col :md="6" style="margin-bottom: 15px">
          <!-- 操作按钮 -->
          <div class="ele-table-tool ele-table-tool-default">
            <el-button @click="setWelcome" type="primary" icon="el-icon-edit" class="ele-btn-icon" size="small">设置欢迎内容</el-button>
            <el-button @click="setNotice" type="primary" icon="el-icon-edit" class="ele-btn-icon" size="small">设置通知</el-button>
            <el-button @click="setMode" type="warning" icon="el-icon-edit" class="ele-btn-icon" size="small">切换模式</el-button>
          </div>
          <!-- 区域列表 -->
          <div class="org-tree-group">
            <el-tree
              ref="orgTree"
              :data="deptData"
              :props="{ label: 'name' }"
              :expand-on-click-node="true"
              node-key="id"
              :default-expanded-keys="dataIdArr"
              @node-click="chooseOrg"
              highlight-current
            />
          </div>
        </el-col>
        <!--班牌列表-->
        <el-col :md="18" style="margin-bottom: 15px">
          <div>
            <el-form
              :model="table.where"
              class="ele-form-search ele-table-tool-default"
              @keyup.enter.native="$refs.table.reload()"
              @submit.native.prevent
            >
              <el-row :gutter="10" style="margin-top: 8px">
                <el-col :md="16" :sm="12">
                  <div class="ele-form-actions">
                    <el-button @click="add" type="primary" size="small" icon="el-icon-plus" class="ele-btn-icon">添加</el-button>
                    <el-button @click="setExam" type="primary" size="small" icon="el-icon-setting" class="ele-btn-icon">设置考试模式</el-button>
                    <el-tooltip content="请在左边选中班级，再进行操作" placement="top">
                      <i class="el-icon-question" style="margin-left: 10px"></i>
                    </el-tooltip>
                  </div>
                </el-col>
              </el-row>
            </el-form>
            <div style="text-align: center; margin: 10px 0">
              <div style="font-weight: 700; font-size: 17px">{{ title }}</div>
            </div>
            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 261px)" highlight-current-row>
              <template #default="{ index }">
                <el-table-column type="selection" width="45" align="center" fixed="left" />
                <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
                <el-table-column prop="uid" label="设备编号" sortable="custom" show-overflow-tooltip />
                <el-table-column label="模式" sortable="custom" show-overflow-tooltip>
                  <template #default="{ row }">
                    {{ row.type === 0 ? '普通模式' : row.type === 1 ? '通知模式' : row.type === 2 ? '欢迎模式' : '考试模式' }}
                  </template> </el-table-column
                >>
                <el-table-column prop="createTime" label="创建时间" sortable="custom" show-overflow-tooltip min-width="110" />
                <el-table-column label="操作" width="230px" align="center" :resizable="false">
                  <template #default="{ row }">
                    <el-popconfirm title="确定要删除此设备吗？" @onConfirm="remove(row)" class="ele-action">
                      <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </template>
            </ele-data-table>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <!--添加班牌弹窗-->
    <el-dialog
      :title="editForm.id ? '修改班牌' : '添加班牌'"
      :visible.sync="showEdit"
      width="400px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px">
        <el-form-item label="设备Id:" prop="uid">
          <el-input v-model="editForm.uid" placeholder="请输入设备Id" readonly clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save(editForm.id)">保存</el-button>
      </div>
    </el-dialog>

    <!--设置学校欢迎内容弹窗-->
    <el-dialog
      title="学校欢迎内容"
      :visible.sync="showWelcome"
      width="450px"
      @closed="welcomeContent = null"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <div style="display: flex; margin-bottom: 20px">
        <div style="width: 80px">内容：</div>
        <el-input type="textarea" :rows="4" maxlength="220" show-word-limit v-model="welcomeContent" placeholder="请输入欢迎内容" />
      </div>
      <div slot="footer">
        <el-button @click="showWelcome = false">取消</el-button>
        <el-button type="primary" @click="saveWelcome">保存</el-button>
      </div>
    </el-dialog>

    <!--设置学校通知弹窗-->
    <el-dialog
      title="学校通知"
      :visible.sync="showNotice"
      width="450px"
      @closed="noticeForm = { noticeContent: '', noticeDate: '', noticeUnit: '' }"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <el-form :model="noticeForm" ref="noticeForm" :rules="noticeRules" label-width="100px">
        <el-form-item label="通知内容:" prop="noticeContent">
          <el-input
            type="textarea"
            :rows="4"
            maxlength="220"
            show-word-limit
            v-model="noticeForm.noticeContent"
            placeholder="请输入通知内容"
            clearable
          />
        </el-form-item>
        <el-form-item label="日期:" prop="noticeDate">
          <el-date-picker value-format="yyyy-MM-dd" v-model="noticeForm.noticeDate" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="通知单位:" prop="noticeUnit">
          <el-input v-model="noticeForm.noticeUnit" placeholder="请输入通知单位" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showNotice = false">取消</el-button>
        <el-button type="primary" @click="saveNotice">保存</el-button>
      </div>
    </el-dialog>

    <!--切换模式-->
    <el-dialog
      title="切换模式"
      :visible.sync="showMode"
      width="400px"
      @closed="modeType = null"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <div style="display: flex; align-items: center; margin-bottom: 20px">
        <div style="width: 80px">模式：</div>
        <el-select v-model="modeType" placeholder="请选择">
          <el-option label="普通模式" :value="0" />
          <el-option label="通知模式" :value="1" />
          <el-option label="欢迎模式" :value="2" />
          <el-option label="考试模式" :value="3" />
        </el-select>
      </div>
      <div slot="footer">
        <el-button @click="showMode = false">取消</el-button>
        <el-button type="primary" @click="saveMode">保存</el-button>
      </div>
    </el-dialog>

    <!--考试模式弹窗-->
    <el-dialog
      title="学校通知"
      :visible.sync="showExam"
      width="450px"
      @closed="examForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <el-form :model="examForm" ref="examForm" :rules="examRules" label-width="100px">
        <el-form-item label="考试内容：" prop="examContent">
          <el-input v-model="examForm.examContent" placeholder="请输入考试内容" clearable />
        </el-form-item>
        <el-form-item label="考场号：" prop="examNumber">
          <el-input v-model="examForm.examNumber" placeholder="请输入考场号" clearable />
        </el-form-item>
        <el-form-item label="开始时间：" prop="beginTime">
          <el-time-picker v-model="examForm.beginTime" placeholder="请选择开始时间" value-format="HH:mm" style="width: 100%" />
        </el-form-item>
        <el-form-item label="结束时间：" prop="endTime">
          <el-time-picker v-model="examForm.endTime" placeholder="请选择结束时间" value-format="HH:mm" style="width: 100%" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showExam = false">取消</el-button>
        <el-button type="primary" @click="saveExam">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    findBranchTreeNameByClassId,
    finiteDataTree,
    addBillboard,
    deleteBillboard,
    getSchoolGreet,
    getSchoolNotice,
    setSchoolGreet,
    setSchoolNotice,
    getBillboardType,
    updateBillboardType,
    getClassExam,
    setClassExam,
  } from '@/config/api';

  export default {
    name: 'Index',
    data() {
      return {
        loading: true, // 加载状态
        deptData: [], // 列表数据
        dataIdArr: [],
        table: {
          // 表格配置
          url: '/billboard/getBillboardListByClass',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        choose: [], //选中的表格数据
        title: '',
        editForm: {}, // 表单数据
        editRules: {
          // 表单验证规则
          uid: [{ required: true, message: '请输入设备id', trigger: 'blur' }],
        },
        showEdit: false,
        classId: null,
        welcomeContent: null, //学校欢迎内容
        noticeForm: {
          noticeContent: '',
          noticeDate: '',
          noticeUnit: '',
        }, //学校通知
        noticeRules: {
          noticeContent: [{ required: true, message: '请输入通知内容', trigger: 'blur' }],
          noticeDate: [{ required: true, message: '请选择日期', trigger: 'change' }],
          noticeUnit: [{ required: true, message: '请输入通知单位', trigger: 'blur' }],
        },

        showWelcome: false, //欢迎内容弹窗
        showNotice: false, //通知弹窗
        showMode: false, //切换模式弹窗
        modeType: null, //模式
        showExam: false, //考试模式弹窗
        examForm: {}, //考试模式表单
        examRules: {
          beginTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
          endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
          examContent: [{ required: true, message: '请输入考试内容', trigger: 'blur' }],
          examNumber: [{ required: true, message: '请输入考场号', trigger: 'blur' }],
        },
      };
    },
    mounted() {
      this.query();
    },
    methods: {
      query() {
        this.loading = true;
        finiteDataTree()
          .then((res) => {
            this.loading = false;
            if (res.data.resCode == 200) {
              this.deptData = res.data.data;
              this.dataIdArr = this.$util.getTreeFloor(this.deptData, 1, this.dataIdArr, 'id');
            } else {
              this.$message.error(res.data.data.resMsg || '获取数据失败');
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
      },
      /* 选择数据 */
      chooseOrg(row) {
        this.$refs.orgTree.setCurrentKey(row.id);
        if (row.orgType === 4) {
          this.queryClassName(row.id.slice(1));
          let obj = {
            classId: row.id.slice(1),
          };
          this.classId = row.id.slice(1);
          this.table.where = obj;
          this.$refs.table.reload();
        } else {
          this.classId = null;
        }
      },
      // 添加
      add() {
        if (this.table.where.classId) {
          this.showEdit = true;
          this.editForm.uid = this.getUid();
        } else {
          this.$message.info('请先选择班级');
        }
      },
      // 保存
      save() {
        this.editForm.classId = this.classId;
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            addBillboard(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      // 删除班牌
      remove(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('id', row.id);
        deleteBillboard(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      //获取学校名字
      queryClassName(classId) {
        let data = {
          classId: classId,
        };
        findBranchTreeNameByClassId(data).then((res) => {
          if (res.data.resCode == 200) {
            this.title = res.data.data;
          }
        });
      },
      // 生成随机六位数
      getUid() {
        let uid = '';
        for (var i = 0; i < 6; i++) {
          uid += Math.floor(Math.random() * 10);
        }
        return uid;
      },
      //打开设置学校欢迎内容弹窗
      setWelcome() {
        this.showWelcome = true;
        getSchoolGreet().then((res) => {
          if (res.data.resCode == 200) {
            this.welcomeContent = res.data.data.content;
          }
        });
      },
      //保存学校欢迎内容
      saveWelcome() {
        let data = new FormData();
        data.append('content', this.welcomeContent);
        setSchoolGreet(data).then((res) => {
          if (res.data.resCode == 200) {
            this.showWelcome = false;
            this.$message({ type: 'success', message: '成功' });
          }
        });
      },
      //设置通知弹窗
      setNotice() {
        this.showNotice = true;
        getSchoolNotice().then((res) => {
          if (res.data.resCode == 200) {
            this.noticeForm.noticeContent = res.data.data.noticeContent;
            this.noticeForm.noticeDate = res.data.data.noticeDate;
            this.noticeForm.noticeUnit = res.data.data.noticeUnit;
          }
        });
      },
      //保存学校通知
      saveNotice() {
        this.$refs['noticeForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let data = new FormData();
            for (let key in this.noticeForm) {
              if (this.noticeForm[key] !== null && this.noticeForm[key] !== undefined) {
                data.append(key, this.noticeForm[key]);
              }
            }
            setSchoolNotice(data).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showNotice = false;
                this.$message({ type: 'success', message: '成功' });
              }
            });
          } else {
            return false;
          }
        });
      },
      //切换模式弹窗
      setMode() {
        this.showMode = true;
        getBillboardType().then((res) => {
          if (res.data.resCode == 200) {
            this.modeType = res.data.data.type;
          }
        });
      },
      //设置模式
      saveMode() {
        let data = new FormData();
        data.append('type', this.modeType);
        updateBillboardType(data).then((res) => {
          if (res.data.resCode == 200) {
            this.showMode = false;
            this.$message({ type: 'success', message: '成功' });
            this.$refs.table.reload();
          }
        });
      },
      //考试模式弹窗
      setExam() {
        if (this.classId) {
          this.showExam = true;
          getClassExam({ classId: this.classId }).then((res) => {
            if (res.data.resCode == 200) {
              this.examForm = Object.assign({}, res.data.data);
            }
          });
        } else {
          this.$message.info('请先选择班级，在进行操作');
        }
      },
      //保存考试模式
      saveExam() {
        this.examForm.classId = this.classId;
        this.$refs['examForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let data = new FormData();
            for (let key in this.examForm) {
              if (this.examForm[key] !== null && this.examForm[key] !== undefined) {
                data.append(key, this.examForm[key]);
              }
            }
            setClassExam(data).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showExam = false;
                this.$message({ type: 'success', message: '成功' });
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>

<style scoped>
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 150px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 30px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
